<template>
  <v-card class="productManagement" flat>
    <v-btn fixed right bottom icon x-large class="indigo" to="/admin/newProduct" style="z-index: 10">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>

    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <v-tabs-items v-model="tab">
      <div class="table" v-infinite-scroll="getProducts" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
        <v-row class="table-header" no-gutters>
          <v-col>商品</v-col>
          <v-col>主播</v-col>
          <v-col>桃子</v-col>
          <v-col>價格 (TWD)</v-col>
          <v-col>類型</v-col>
          <v-col v-if="tab == 0 || tab == 1 || tab == 4">是否上架</v-col>
          <v-col v-if="tab == 2 || tab == 3 || tab == 4">是否售出</v-col>
          <v-col>建立日期</v-col>
          <v-col style="min-width: 100px; max-width: 100px"></v-col>
        </v-row>
        <div class="table-body">
          <template v-for="product in products">
            <v-row class="table-content" no-gutters>
              <v-col>
                <v-img 
                  :src="$func.productImagePreview(product)" 
                  aspect-ratio="1"
                  max-width="50"
                  width="50"
                  class="mr-2"
                ></v-img>
                {{ product.title }}
              </v-col>
              <v-col>{{ product.nickname }}</v-col>
              <v-col>
                <div class="peach"></div>
                {{ product.price }}
              </v-col>
              <v-col>{{ Math.ceil(product.price / $EXCHANGE_RATE) }}</v-col>
              <!-- <v-col>{{ clothes_types.find(type => type.num == product.type).name }}</v-col> -->
              <v-col>{{ $product_types.find(type => type.value == product.product_type).text }}</v-col>
              <v-col v-if="tab == 0 || tab == 1 || tab == 4" :class="[product.shelf > 0 ? 'green--text' : 'red--text']">
                {{ product.shelf > 0 ? '是' : '否' }}
              </v-col>
              <v-col v-if="tab == 2 || tab == 3 || tab == 4" :class="[product.sold > 0 ? 'green--text' : 'red--text']">
                {{ product.sold > 0 ? '是' : '否' }}
              </v-col>
              <v-col>{{ product.created_at | formatDate }}</v-col>
              <v-col style="min-width: 100px; max-width: 100px">
                <v-btn icon color="indigo" :to="`/admin/product/${product.id}`">
                  <v-icon>fa-edit</v-icon>
                </v-btn>
                <DeleteConfirmBtn icon color="red" @delete="deleteProduct(product)">
                  <v-icon>fa-trash-alt</v-icon>
                </DeleteConfirmBtn>
              </v-col>
            </v-row>
          </template>
        </div>
      </div>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { DeleteConfirmBtn, AdminToolbar },
  data() {
    return {
      page: 1,
      busy: false,
      searchTypes: [
        { text: '主播', table: 'sellers', column: 'nickname' },
        { text: '職業', table: 'sellers', column: 'job' },
        { text: '商品標題', table: 'products', column: 'title' },
        { text: '商品類型', table: 'products', column: 'type' },
      ],
      sortTypes: [
        { text: '建立日期', table: 'products', column: 'created_at', by: 'desc' },
        { text: '商品類型', table: 'products', column: 'type', by: 'desc' },
        { text: '價格', table: 'products', column: 'price', by: 'desc' },
        { text: '主播', table: 'sellers', column: 'nickname', by: 'desc' },
      ],
      sort: '',
      tabs: [
        {text: '未售出', column: 'sold', value: [0, 0]},
        {text: '已售出', column: 'sold', value: [1, 1]},
        {text: '上架中', column: 'shelf', value: true},
        {text: '下架中', column: 'shelf', value: false},
        {text: '全部'},
      ],
      tab: 0,
      search_condition: [],
      products: []
    }
  },
  created() {
    this.search = this.searchTypes[0]
    this.sort = this.sortTypes[0]
  },
  computed: {
    ...mapState('global', ['clothes_types', 'seller_job_types']),
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.products = []
      this.getProducts()
    },
    deleteProduct(product) {
      this.axios.delete(`/admin/products`, {
        data: {
          id: [product.id]
        }
      }).then(response => {
        this.products.splice(this.products.indexOf(product), 1)
        this.$root.$emit('alert', 'success', '刪除成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '刪除失敗')
      })
    },
    getProducts() {
      var search_condition = []
      search_condition = this.search_condition
      if(this.tab != 4) {
        search_condition = this.search_condition.concat({table: 'products', column: this.tabs[this.tab].column, keyword: this.tabs[this.tab].value})
      }
      this.busy = true
      let origin = this.tab
      this.axios.post('/admin/products', {
        search: search_condition,
        page: this.page,
        size: 50,
        sort: this.sort,
        includeSeller: true
      }).then(response => {
        if(origin != this.tab) {
          return
        }
        this.products = this.products.concat(response.data.data) 
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
  }
}
</script>

<style lang="scss">
.productManagement {
  
}
</style>